import { Card, CardTitle } from '@/components/ui/card';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { DashboardContent } from '@/layouts/dashboard';
import { useEffect, useState } from 'react';
import { FiDownload, FiEye } from 'react-icons/fi';

const EJASchedule = [
  {
    course: 'EJATEC Técnico em Administração',
    subtitle: 'Módulo 01',
    schedule: '/grade-horaria-sem-logo/EJA/modulo-01.jpeg'
  },
  {
    course: 'EJATEC Técnico em Administração',
    subtitle: 'Módulo 02',
    schedule: '/grade-horaria-sem-logo/EJA/modulo-02.jpeg'
  },
  {
    course: 'EJATEC Técnico em Administração',
    subtitle: 'Módulo 04',
    schedule: '/grade-horaria-sem-logo/EJA/modulo-04.jpeg'
  },
  {
    course: 'EJA ETAPA V',
    subtitle: 'Qualificação Profissional',
    schedule: '/grade-horaria-sem-logo/EJA/qualificacao-profissional-etapa-v.png'
  },
  {
    course: 'EJA ETAPA V',
    subtitle: 'Qualificação Profissional em Auxiliar Administrativo',
    schedule: '/grade-horaria-sem-logo/EJA/qualificacao-profissional-aux-adm-etapa-v.png'
  }
];

const EM1Schedule = [
  {
    course: '1ª Série Parcial Noturna',
    subtitle: 'Integrada com o Tec. em Administração',
    schedule: '/grade-horaria-sem-logo/EM1/parcial-noturna.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Agropecuária',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-agropecuaria.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Administração com Ênfase em Empreendedorismo',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-administracao.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Alimentos',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-alimentos.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Análises Clínicas',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-analises-clinicas.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Artesanato com Ênfase em Empreendedorismo',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-artesanata.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Avicultor',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-avicultor.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Bovinocultor de Leite',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-bovinocultor-de-leite.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Controle Ambiental',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-controle-ambiental.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Desenvolvimento de Sistemas',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-desenvolvimento-de-sistemas.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Farmácia',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-farmacia.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Guia de Turismo',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-guia-de-turismo.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Logística',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-logistica.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Marketing Digital',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-marketing-digital.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Modelagem do Vestuário',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-modelagem-do-vestuario.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Planejamento e Controle da Produção',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-planejamento-e-controle-da-producao.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Programação de Jogos Digitais',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-programacao-de-jogos-digitais.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Segurança do Trabalho',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-seguranca-do-trabalho.png'
  },
  {
    course: '1ª Série Integral',
    subtitle: 'Técnico em Sistemas de Energias Renováveis',
    schedule: '/grade-horaria-sem-logo/EM1/tecnico-em-sistemas-de-energia-renovaveis.png'
  }
];

const EM2Schedule = [
  {
    course: '2ª Série Integral',
    subtitle: '',
    schedule: '/grade-horaria-sem-logo/EM2/integral.png'
  },
  {
    course: '2ª Série Parcial Noturna',
    subtitle: 'Integrada com o Tec. em Administração',
    schedule: '/grade-horaria-sem-logo/EM2/parcial-noturna.png'
  }
];

const EM3Schedule = [
  {
    course: '3ª Série Parcial Regular Noturna',
    subtitle: '',
    schedule: '/grade-horaria-sem-logo/EM3/parcial-noturna.png'
  },
  {
    course: '3ª Série Integral',
    subtitle: '',
    schedule: '/grade-horaria-sem-logo/EM3/integral.png'
  },
  {
    course: '3ª Série Parcial Tarde',
    subtitle: '',
    schedule: '/grade-horaria-sem-logo/EM3/parcial-tarde.png'
  },
  {
    course: '3ª Série Parcial Manhã',
    subtitle: '',
    schedule: '/grade-horaria-sem-logo/EM3/parcial-manha.png'
  }
];

export function CourseSchedule(props) {
  const connection = localStorage.getItem('DBNumber');

  const { uri } = props;
  const [openModal, setOpenModal] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [currentSchedule, setCurrentSchedule] = useState(null);

  useEffect(() => {
    switch (connection) {
      case '4': // EJA
        setCurrentSchedule(EJASchedule);
        break;
      case '3': // EM1
        setCurrentSchedule(EM1Schedule);
        break;
      case '2': // EM2
        setCurrentSchedule(EM2Schedule);
        break;
      case '1': // EM3
        setCurrentSchedule(EM3Schedule);
        break;
      default:
        setCurrentSchedule(null);
    }
  }, [connection]);

  const breadcrumbs = {
    title: 'Cursos e Aulas',
    nav: [
      {
        route: uri,
        name: 'Horários',
        isActive: true
      }
    ]
  };

  const handleDownload = url => {
    const link = document.createElement('a');
    link.href = url;
    link.download = 'grade-horaria.jpg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <DashboardContent breadcrumbs={breadcrumbs}>
      <p className="mb-4">Clique nos cursos abaixo para visualizar a grade horária</p>
      <div className="grid grid-cols-3 gap-2">
        {currentSchedule?.map(item => (
          <Card
            className="min-h-20 cursor-pointer"
            hover
            onClick={() => {
              setSelectedSchedule(item);
              setOpenModal(true);
            }}
          >
            <div className="flex h-full w-full items-center gap-2 px-3">
              <div className="flex-1">
                <CardTitle>{item.course}</CardTitle>
                <p className="mb-0">{item.subtitle}</p>
              </div>

              <FiEye className="h-6 w-6 text-primary" />
            </div>
          </Card>
        ))}
      </div>

      <Dialog
        open={openModal}
        onOpenChange={() => setOpenModal(false)}
      >
        <DialogContent size="full">
          <FiDownload
            className="absolute right-12 top-3.5 h-5 w-5 cursor-pointer text-primary"
            onClick={() => handleDownload(selectedSchedule?.schedule)}
          />
          {selectedSchedule && (
            <img
              src={selectedSchedule.schedule}
              alt="Horário"
              className="mt-3 w-full"
            />
          )}
        </DialogContent>
      </Dialog>
    </DashboardContent>
  );
}
